import { render } from "./ChatPrev.vue?vue&type=template&id=5781e991&scoped=true"
import script from "./ChatPrev.vue?vue&type=script&lang=js"
export * from "./ChatPrev.vue?vue&type=script&lang=js"

import "./ChatPrev.vue?vue&type=style&index=0&id=5781e991&scoped=true&lang=scss"

import exportComponent from "D:\\myGithub\\customer-web-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5781e991"]])

export default __exports__